/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_World_Reset_ToastInputs */

const en_chat_world_reset_toast = /** @type {(inputs: Chat_World_Reset_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chat history cleared after world switch.`)
};

const fr_chat_world_reset_toast = /** @type {(inputs: Chat_World_Reset_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Historique du chat effacé suite au changement de monde.`)
};

const ms_sg2_chat_world_reset_toast = /** @type {(inputs: Chat_World_Reset_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sejarah sembang dipadam selepas tukar dunia.`)
};

/**
* | output |
* | --- |
* | "Chat history cleared after world switch." |
*
* @param {Chat_World_Reset_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const chat_world_reset_toast = /** @type {((inputs?: Chat_World_Reset_ToastInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_World_Reset_ToastInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chat_world_reset_toast(inputs)
	if (locale === "fr") return fr_chat_world_reset_toast(inputs)
	return ms_sg2_chat_world_reset_toast(inputs)
});